import React from 'react';
import PropTypes from 'prop-types';
import Error from '@/modules/common/components/Error';
import Button from '@/modules/common/components/Button';

const ErrorFetch = (props) => {
    return (
        <Error className="error-fetch">
            <Button color="secondary" onClick={props.onClick}>Повторить попытку</Button>
        </Error>
    );
};

ErrorFetch.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default ErrorFetch;
